import { parseRdfQuadsWithN3 } from "../n3/n3-adapter.js";
export async function fetchRdfQuadsBySparqlConstruct(httpFetch, endpoint, query) {
    const format = "text/plain";
    const url = createSparqlQueryUrl(endpoint, query, format);
    const headers = { Accept: format };
    const response = await httpFetch(url, { headers: headers });
    const content = await response.text();
    return await parseRdfQuadsWithN3(content);
}
export function createSparqlQueryUrl(endpoint, query, format) {
    return (endpoint +
        "?format=" +
        encodeURIComponent(format) +
        "&query=" +
        encodeURIComponent(query));
}
//# sourceMappingURL=sparql-adapter.js.map